module.exports = __webpack_public_path__ + "static/img/ab_onboarding.5607c7a0.png";